import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

import { MODAL_FOOTER_HEIGHT } from "./constants/modalFooterHeight";

export const footerStyle = css`
  height: ${MODAL_FOOTER_HEIGHT}px; /* modalStyle で grid-template-rows を指定する関係 */

  ${MEDIA_QUERY_FOR_PC} {
    column-gap: 10px;
    justify-content: right;
    padding: 16px 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    column-gap: 8px;
    justify-content: right;
    padding: 12px 18px;
  }
`;

export const resultCountStyle = css`
  font-size: 18px;
  font-weight: 700;
  margin-right: auto;
`;

export const buttonsWrapperStyle = css`
  column-gap: 10px;
  display: grid;
  grid-template-columns: 159px 140px;
  margin-top: 10px;

  ${MEDIA_QUERY_FOR_PC} {
    justify-content: flex-end;
  }

  ${MEDIA_QUERY_FOR_SP} {
    justify-content: center;
  }
`;

export const searchButtonStyle = css`
  align-items: center;
  display: flex;
  font-size: 16px;
  justify-content: center;
  line-height: 1.5;
  padding: 8px 12px;

  ${MEDIA_QUERY_FOR_PC} {
    column-gap: 8px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    border-radius: 4px;
    column-gap: 6px;
  }
`;

export const searchIconStyle = css`
  height: 16px;
  width: 16px;
`;
